import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'
const url = store.getters.getPostUrl;
export default {
  comprehensive(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/statistics/comprehensive',
      method: 'post',
      data:param
    })
  },
  comprehensiveExcel(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/statistics/comprehensiveExcel',
      method: 'post',
      data:param
    })
  },

  repair1(param){
    return request({
      url: store.getters.getPostUrl + 'mes/statistics/repair1',
      method: 'post',
      data:param
    })
  },
  repair1Excel(param){
    return request({
      url: store.getters.getPostUrl + 'mes/statistics/repair1Excel',
      method: 'post',
      data:param
    })
  },
  repair2(param){
    return request({
      url: store.getters.getPostUrl + 'mes/statistics/repair2',
      method: 'post',
      data:param
    })
  },
  repair2Excel(param){
    return request({
      url: store.getters.getPostUrl + 'mes/statistics/repair2Excel',
      method: 'post',
      data:param
    })
  },



	maintain(param) {
	  return request({
	    url: store.getters.getPostUrl + 'mes/statistics/maintain',
	    method: 'post',
	    data:param
	  })
	},
	maintainExcel(param) {
	  return request({
	    url: store.getters.getPostUrl + 'mes/statistics/maintainExcel',
	    method: 'post',
	    data:param
	  })
	},

  // checkStatistics(param) {
  //   return request({
  //     url: store.getters.getPostUrl + 'mes/statistics/checkStatistics',
  //     method: 'post',
  //     data:param
  //   })
  // },

  // 获取点检统计数据
  checkStatistics(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/statistics/checkStatistics',
      method: 'post',
      data: params
    })
  },

    // 获取点检表格时长统计数据
  spotCheckTimeStatistics(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/statistics/spotCheckTimeStatistics',
      method: 'post',
      data: params
    })
  },

    // 获取点检图标NG统计数据
  spotCheckNgStatistics(params) {
    return request({
      url: store.getters.getPostUrl + 'mes/statistics/spotCheckNgStatistics',
      method: 'post',
      data: params
    })
  },

}



// WEBPACK FOOTER //
// ./src/assets/js/statistics/statistics.js